var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbmeldenGrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-account-logout",
    className: "cls-1",
    d: "M15,25.88v-3.7H3V3.7H15V0H0V25.88H15Zm3-7.39l6-5.54-6-5.54v3.7H6v3.7h12v3.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbmeldenGrau);
export default __webpack_public_path__ + "static/media/Abmelden_grau.085c8efd453bb440ebae144e18e150a2.svg";
export { ForwardRef as ReactComponent };